import { render, staticRenderFns } from "./BigScreen.vue?vue&type=template&id=48cfbe98&scoped=true&"
import script from "./BigScreen.vue?vue&type=script&lang=js&"
export * from "./BigScreen.vue?vue&type=script&lang=js&"
import style0 from "./BigScreen.vue?vue&type=style&index=0&id=48cfbe98&lang=scss&scoped=true&"
import style1 from "./BigScreen.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cfbe98",
  null
  
)

export default component.exports